import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient } from "@tanstack/react-query";

/** Clé du cache de lecture gardé sur le téléphone (effacé à la déconnexion : lib/forget.ts). */
export const QUERY_CACHE_KEY = "sk-query-cache";

// Lecture hors ligne : les écrans connus s'affichent depuis le cache, puis se rafraîchissent.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, gcTime: 24 * 3600_000, networkMode: "offlineFirst", retry: 2 },
  },
});

export const persister = createSyncStoragePersister({ storage: window.localStorage, key: QUERY_CACHE_KEY });
